















































import {Component, Vue, Watch} from 'vue-property-decorator'
import firebase from 'firebase/app'
import 'firebase/firestore'
import {DB} from '@/enum/db'

@Component
export default class Register extends Vue {
  private form = false
  private dateMenu = false
  private date = new Date().toISOString().substr(0, 10)

  private rules = {
    required: (value: string) => !!value || '必須項目',
  }

  private alert = {
    show: false,
    type: 'success',
    message: '登録完了',
  }

  private group: Group = {
    name: '',
    bio: '',
    thumbnailUrl: '',
    discord: '',
    baseWorldId: '',
    owner: '',
    members: [],
    tags: [],
    since: new Date(this.date),
  }

  private async registerGroup() {
    if (this.form) {
      const firestore = firebase.firestore()
      const result = await firestore.collection(DB.groups).add(this.group)
      let userData = this.$store.state.userData as UserData
      if (userData) {
        userData.editorGroups.push(result.id)
        await firestore.collection(DB.userdata).doc(this.$store.getters.userId)
          .update({editorGroups: userData.editorGroups})
      } else {
        userData = {
          editorGroups: [result.id],
        }
        await firestore.collection(DB.userdata).doc(this.$store.getters.userId)
          .set(userData)
      }
    }
    this.showAlert(this.form)
  }

  private showAlert(success: boolean) {
    if (success) {
      this.alert.type = 'success'
      this.alert.message = '登録完了'
      this.alert.show = true
    } else {
      this.alert.type = 'error'
      this.alert.message = '入力に不備があります'
      this.alert.show = true
    }
  }

  private removeTag(item: string, arr: string[]) {
    arr.splice(arr.indexOf(item), 1)
  }

  @Watch('date')
  private onChangeDate(value: string) {
    this.group.since = new Date(value)
  }
}
